import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '@/utils/filters'
import store from './store'
import VueAnimateOnScroll from 'vue-animate-onscroll'
import vuescroll from 'vuescroll'
import VueScrollTo from 'vue-scrollto'
import vClickOutside from 'v-click-outside'
import Vue2TouchEvents from 'vue2-touch-events'

Vue.config.productionTip = false

Vue.use(VueAnimateOnScroll)
Vue.use(vuescroll)
Vue.use(vClickOutside)
Vue.use(VueScrollTo)
Vue.use(Vue2TouchEvents)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
